/** Stands in for the image URL in the sortable id of an empty slot, which has no photo. */
export const PHOTO_GUIDE_SLOT_DND_URL = 'photo-guide-slot';
